import { render, staticRenderFns } from "./GroupStatisticsDialog.vue?vue&type=template&id=88b512da&scoped=true&"
import script from "./GroupStatisticsDialog.vue?vue&type=script&lang=js&"
export * from "./GroupStatisticsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b512da",
  null
  
)

export default component.exports